export { default } from '@ember-data/debug/data-adapter';
